import { Empty } from 'antd';
import * as BuyIntentionModels from 'model/BuyIntention';
import { useEffect, useState } from 'react';
import BuyIntentionItemModals, {
  BuyIntentionItemsLoading,
} from '../BuyIntentionItemModals';
import { useBuyIntentionItemActions } from '../useBuyIntentionItemActions';
import BuyIntentionItemCard from './BuyIntentionItemCard';
import BuyIntentionItemSheet from './BuyIntentionItemSheet';
import * as S from './styles';

export const CARDS_BLOCK_SIZE = 20;

interface Props {
  tableData: BuyIntentionModels.BuyIntentionData[];
}

export default function BuyIntentionItemCardList({ tableData }: Props) {
  const actions = useBuyIntentionItemActions();
  const [visibleCount, setVisibleCount] = useState(CARDS_BLOCK_SIZE);
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined);

  const items = tableData ?? [];
  const firstItemId = items[0]?.id;

  useEffect(() => {
    setVisibleCount(CARDS_BLOCK_SIZE);
  }, [firstItemId]);

  const selectedItem = items.find((item) => item.id === selectedId);

  return (
    <>
      <BuyIntentionItemModals actions={actions} />

      {items.length === 0 ? (
        <S.Empty>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </S.Empty>
      ) : (
        <S.List aria-label="Produtos">
          {items.slice(0, visibleCount).map((item) => (
            <BuyIntentionItemCard
              key={item.id}
              item={item}
              currentStep={actions.currentStep}
              total={actions.handleTotalPrice(item)}
              onOpen={(opened) => setSelectedId(opened.id)}
            />
          ))}
        </S.List>
      )}

      {items.length > visibleCount && (
        <S.LoadMore
          onClick={() => setVisibleCount((count) => count + CARDS_BLOCK_SIZE)}
        >
          {`Carregar mais (${items.length - visibleCount})`}
        </S.LoadMore>
      )}

      <BuyIntentionItemSheet
        item={selectedItem}
        actions={actions}
        onClose={() => setSelectedId(undefined)}
      />

      <BuyIntentionItemsLoading isLoading={actions.isLoading} />
    </>
  );
}
